import styled from 'styled-components';
import theme from '../../assets/styles/theme';
import Flex from '../Flex/Flex';

const CuitSelector = styled(Flex)`
  display: flex;
  align-items: center;
  background-color: ${theme.colors.neutral.bg.weak};
`;

const IconWrapper = styled(Flex)`
  background-color: ${theme.colors.primary.bg.regular};
  height: 32px;
  width: 32px;
  border-radius: ${theme.borderRadius['border-radius-5']};
  align-items: center;
  justify-content: center;
  margin-right: ${theme.spacing['spacing-8']};
`;

const TextWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;

export { CuitSelector, IconWrapper, TextWrapper };
